module.exports = __webpack_public_path__ + "847e715456418d5cf07d5d141e269dfa.svg";